import { Text } from "./text";

class InputsPassword extends Text {
}

riot.mixin("inputs.password", InputsPassword as riot.TagMixin)
